// import React, { useEffect, useState } from "react";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";
// import { jwtDecode } from "jwt-decode";
// import Logo from "../../Assets/HRMS1.jpg";
// import { useNavigate } from "react-router-dom";
// import MenuIcon from "@mui/icons-material/Menu";
// import { TiArrowSortedDown } from "react-icons/ti";

// const Navbar = ({ transparent = false, onHamburgerClick }) => {
//   const [employeeName, setEmployeeName] = useState("");
//   const [employeeId, setEmployeeId] = useState("");
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const token = sessionStorage.getItem("token");
//   const role = sessionStorage.getItem("role");

//   useEffect(() => {
//     if (token) {
//       try {
//         const decodedToken = jwtDecode(token);
//         setEmployeeName(decodedToken.employee?.name || "");
//         setEmployeeId(decodedToken.employee?.employeeid || "");
//       } catch (error) {
//         console.error("Token decoding failed", error);
//       }
//     }
//   }, [token]);

//   const handleLoginClick = () => navigate("/login");
//   const handleLogoutClick = () => {
//     sessionStorage.removeItem("token");
//     sessionStorage.removeItem("role");
//     setEmployeeName("");
//     setEmployeeId("");
//     navigate("/");
//   };

//   // mobile dropdown
//   const toggleDropdown = () => setDropdownOpen((prev) => !prev);

//   return (
//     <AppBar
//       position="sticky"
//       sx={{
//         background: transparent
//           ? "transparent"
//           : "linear-gradient(90deg,rgb(50, 122, 205),rgb(94, 169, 244))",
//         boxShadow: transparent ? "none" : "0 4px 6px rgba(0,0,0,0.1)",
//         transition: "background 0.3s ease",
//       }}
//     >
//       <Toolbar
//         sx={{
//           display: "flex",
//           flexWrap: "nowrap",
//           justifyContent: "space-between",
//           alignItems: "center",
//           px: { xs: 2, sm: 3, md: 4 },
//           minHeight: { xs: 64, sm: 70, md: 80 },
//           position: "relative",
//         }}
//       >
//         {/* Left: Logo and Sidebar Hamburger */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           {isMobile && (
//             <IconButton
//               edge="start"
//               aria-label="sidebar toggle"
//               onClick={onHamburgerClick}
//               sx={{ color: "white" }}
//             >
//               <MenuIcon sx={{ fontSize: 28 }} />
//             </IconButton>
//           )}
//           {/* <IconButton edge="start" aria-label="logo" sx={{ p: 0 }}>
//             <Box
//               component="img"
//               src={Logo}
//               alt="Brand Logo"
//               sx={{
//                 width: { xs: 45, sm: 55, md: 65 },
//                 height: { xs: 45, sm: 55, md: 65 },
//                 borderRadius: "50%",
//                 objectFit: "cover",
//                 border: "2px solid white",
//               }}
//             />
//           </IconButton> */}
//         </Box>

//         {/* Center: Employee Info */}
//         {!isMobile && (
//           <Box sx={{ flexGrow: 1, mx: 2, textAlign: "center" }}>
//             {employeeName && employeeId && (
//               <Box
//                 sx={{
//                   fontWeight: "600",
//                   fontSize: "1rem",
//                   color: "white",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {role}: {employeeName} ({employeeId})
//               </Box>
//             )}
//           </Box>
//         )}

//         {/* Right Section */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           {!isMobile && (
//             <>
//               {token ? (
//                 <Button
//                   variant="contained"
//                   onClick={handleLogoutClick}
//                   sx={{
//                     textTransform: "none",
//                     fontWeight: "bold",
//                     borderRadius: 2,
//                     backgroundColor: "white",
//                     border: "2px solid white",
//                     color: "white",
//                     "&:hover": { backgroundColor: "#e3f2fd" },
//                     px: 3,
//                     py: 1,
//                   }}
//                 >
//                   Logout
//                 </Button>
//               ) : (
//                 <Button
//                   variant="outlined"
//                   onClick={handleLoginClick}
//                   sx={{
//                     textTransform: "none",
//                     fontWeight: "bold",
//                     borderRadius: 2,
//                     borderColor: "white",
//                     color: "white",
//                     "&:hover": {
//                       backgroundColor: "rgba(255,255,255,0.2)",
//                       borderColor: "white",
//                     },
//                     px: 3,
//                     py: 1,
//                   }}
//                 >
//                   Login
//                 </Button>
//               )}
//             </>
//           )}
//           {/* Mobile: Right Hamburger to toggle dropdown */}
//           {isMobile && (
//             <IconButton
//               onClick={toggleDropdown}
//               sx={{ color: "white" }}
//               aria-label="user details toggle"
//             >
//               <TiArrowSortedDown sx={{ fontSize: 28 }} />
//             </IconButton>
//           )}
//           {/* Mobile Dropdown */}
//           {isMobile && dropdownOpen && (
//             <Box
//               className="navbar-dropdown"
//               sx={{
//                 position: "absolute",
//                 top: "64px",
//                 right: 16,
//                 background: "white",
//                 border: "1px solid #ddd",
//                 borderRadius: "4px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 zIndex: 1000,
//                 minWidth: "220px",
//               }}
//             >
//               <Box sx={{ px: 2, py: 1, borderBottom: "1px solid #ddd" }}>
//                 <span style={{ fontWeight: "bold", color: "#0d47a1" }}>
//                   {role}: {employeeName} ({employeeId})
//                 </span>
//               </Box>
//               <Box sx={{ p: 1 }}>
//                 {token ? (
//                   <Button
//                     variant="contained"
//                     onClick={handleLogoutClick}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: "bold",
//                       borderRadius: 2,
//                       backgroundColor: "white",
//                       color: "#0d47a1",
//                       "&:hover": { backgroundColor: "#e3f2fd" },
//                       width: "100%",
//                     }}
//                   >
//                     Logout
//                   </Button>
//                 ) : (
//                   <Button
//                     variant="outlined"
//                     onClick={handleLoginClick}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: "bold",
//                       borderRadius: 2,
//                       borderColor: "white",
//                       color: "white",
//                       "&:hover": {
//                         backgroundColor: "rgba(99, 161, 254, 0.2)",
//                         borderColor: "blue",
//                       },
//                       width: "100%",
//                     }}
//                   >
//                     Login
//                   </Button>
//                 )}
//               </Box>
//             </Box>
//           )}
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;




///////////////////////Rishabh Version Start/////////////
// import React, { useEffect, useState } from "react";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";
// import { jwtDecode } from "jwt-decode";
// import Typography from "@mui/material/Typography";
// import MenuIcon from "@mui/icons-material/Menu";
// import IconButton from "@mui/material/IconButton";
// import { useNavigate } from "react-router-dom";
// import "./Navbar.css";

// const Navbar = ({ transparent = false, onHamburgerClick }) => {
//   const [employeeName, setEmployeeName] = useState("");
//   const [employeeId, setEmployeeId] = useState("");

//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const token = sessionStorage.getItem("token");
//   const role = sessionStorage.getItem("role");

//   useEffect(() => {
//     if (token) {
//       try {
//         const decodedToken = jwtDecode(token);
//         setEmployeeName(decodedToken.employee?.name || "");
//         setEmployeeId(decodedToken.employee?.employeeid || "");
//       } catch (error) {
//         console.error("Token decoding failed", error);
//       }
//     }
//   }, [token]);

//   const handleLoginClick = () => navigate("/login");

//   const handleLogoutClick = () => {
//     sessionStorage.removeItem("token");
//     sessionStorage.removeItem("role");
//     setEmployeeName("");
//     setEmployeeId("");
//     navigate("/");
//   };

//   return (
//     <AppBar
//       position="fixed"
//       sx={{
//         background: transparent
//           ? "transparent"
//           : "linear-gradient(90deg, #2b6cb0, #4299e1)",
//         boxShadow: transparent ? "none" : "0 2px 6px rgba(0,0,0,0.15)",
//          marginBottom: '16px' 
//       }}
//     >
//     <Toolbar
//   disableGutters
//   sx={{
//     display: "flex",
//     justifyContent: employeeId ? "space-between" : "space-between",
//     alignItems: "center",
//     px: { xs: 1, sm: 2 },
//     py: 0.25,
//     minHeight: { xs: 44, sm: 52, md: 56 },
//     backgroundColor: employeeId ? "#ffffff" : "transparent",
//     width: "100%",
//   }}
// >
//   {/* Left Logo or Hamburger */}
//   <Box sx={{ display: "flex", alignItems: "center" }}>
//     {isMobile ? (
//       <IconButton
//         edge="start"
//         aria-label="sidebar toggle"
//         onClick={onHamburgerClick}
//         sx={{ color: employeeId ? "#2b6cb0" : "#ffffff", ml: 1 }}
//       >
//         <MenuIcon sx={{ fontSize: 28 }} />
//       </IconButton>
//     ) : (
//       <div className="navbar-logo">
//         <span className="logo-text" style={{ color: employeeId ? "#2b6cb0" : "#ffffff" }}>Infy</span>
//         <span className="logo-bold" style={{ color: employeeId ? "#2b6cb0" : "#ffffff" }}>HR</span>
//       </div>
//     )}
//   </Box>

//   {/* Center: Searchbar if logged in */}
//   {employeeId && (
//     <Box
//       sx={{
//         flexGrow: 1,
//         display: "flex",
//         justifyContent: "center",
//         px: 2,
//       }}
//     >
//       <Box
//         sx={{
//           backgroundColor: "#f5f5f5",
//           borderRadius: "999px",
//           display: "flex",
//           alignItems: "center",
//           px: 2,
//           py: 0.7,
//           width: "100%",
//           maxWidth: 500,
//           boxShadow: "inset 0 0 0 1px #ddd",
//         }}
//       >
//         <span style={{ marginRight: 8, color: "#999" }}>🔍</span>
//         <input
//           type="text"
//           placeholder="Search employees, departments..."
//           style={{
//             border: "none",
//             outline: "none",
//             background: "transparent",
//             fontSize: "0.9rem",
//             color: "#333",
//             width: "100%",
//           }}
//         />
//       </Box>
//     </Box>
//   )}

//   {/* Right: Login / Logout */}
//   <Box>
//     {token ? (
//       <Button
//         variant="contained"
//         onClick={handleLogoutClick}
//         sx={{
//           backgroundColor: employeeId ? "#2b6cb0" : "#ffffff",
//           color: "#ffffff",
//           fontWeight: 600,
//           textTransform: "none",
//           px: 2,
//           fontSize: "0.7rem",
//           borderRadius: "6px",
//           minHeight: "28px",
//           "&:hover": {
//             backgroundColor: "#245a98",
//           },
//         }}
//       >
//         Logout
//       </Button>
//     ) : (
//       <Button
//         variant="outlined"
//         onClick={handleLoginClick}
//         sx={{
//           color: "#ffffff",
//           borderColor: "#ffffff",
//           fontWeight: 600,
//           textTransform: "none",
//           px: 2,
//           fontSize: "0.7rem",
//           borderRadius: "6px",
//           minHeight: "28px",
//           "&:hover": {
//             backgroundColor: "rgba(255,255,255,0.2)",
//           },
//         }}
//       >
//         Login
//       </Button>
//     )}
//   </Box>
// </Toolbar>

//     </AppBar>
//   );
// };

// export default Navbar;
//////////////////////////////////////// Rishabh Second version start

import React, { useEffect, useState } from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import FullscreenRoundedIcon from "@mui/icons-material/FullscreenRounded";
import FullscreenExitRoundedIcon from "@mui/icons-material/FullscreenExitRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import Badge from "@mui/material/Badge";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";


const Navbar = ({ transparent = false, onHamburgerClick }) => {
  const [employeeName, setEmployeeName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setEmployeeName(decodedToken.employee?.name || "");
        setEmployeeId(decodedToken.employee?.employeeid || "");
        setEmployeeEmail(decodedToken.employee?.email || "");
      } catch (error) {
        console.error("Token decoding failed", error);
      }
    }
  }, [token]);


  ///////Fullscreen working 
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };


  /////////userinfo working
  const [userCardAnchorEl, setUserCardAnchorEl] = useState(null);
  const openUserCard = Boolean(userCardAnchorEl);

  const handleUserIconClick = (event) => {
    setUserCardAnchorEl(event.currentTarget);
  };

  const handleUserCardClose = () => {
    setUserCardAnchorEl(null);
  };





  const handleLoginClick = () => navigate("/login");

  const handleLogoutClick = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    setEmployeeName("");
    setEmployeeId("");
    setEmployeeEmail("");
    navigate("/");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        background: token
          ? "#fff"
          : "linear-gradient(135deg, #1e3c72, #2a5298, #667eea)",
        borderBottom: token ? "1px solid #eef0f6" : "none",
        boxShadow: transparent
          ? "none"
          : "0 2px 12px rgba(0,0,0,0.06)",
        zIndex: 1100,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 1, sm: 2.5, md: 3 },
          height: { xs: 56, sm: 64 },
          minHeight: { xs: 56, sm: 64 },
        }}
      >
        {/* ========== LEFT SECTION ========== */}
        <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          {isMobile ? (
            <>
              <IconButton
                edge="start"
                aria-label="sidebar toggle"
                onClick={onHamburgerClick}
                sx={{
                  ml: 0.5,
                  background: token
                    ? "linear-gradient(135deg, #667eea, #764ba2)"
                    : "rgba(255,255,255,0.15)",
                  WebkitBackgroundClip: token ? "unset" : "unset",
                  color: token ? "#fff" : "#fff",
                  borderRadius: "10px",
                  p: 0.75,
                  "&:hover": {
                    background: token
                      ? "linear-gradient(135deg, #5a6fd6, #6a4296)"
                      : "rgba(255,255,255,0.25)",
                  },
                }}
              >
                <MenuIcon sx={{ fontSize: 22 }} />
              </IconButton>
              <Typography
                sx={{
                  ml: 1,
                  fontWeight: 700,
                  fontSize: "1rem",
                  background: token
                    ? "linear-gradient(135deg, #667eea, #764ba2)"
                    : "none",
                  WebkitBackgroundClip: token ? "text" : "unset",
                  WebkitTextFillColor: token ? "transparent" : "#fff",
                  color: token ? "transparent" : "#fff",
                }}
              >
                InfyU
              </Typography>
            </>
          ) : (
            <div className="navbar-logo">
              <span className={token ? "logo-text logo-gradient" : "logo-text logo-white"}>
                InfyU
              </span>
              <span className={token ? "logo-bold logo-dark" : "logo-bold logo-white"}>
                LABS
              </span>
            </div>
          )}
        </Box>

        {/* ========== CENTER SECTION (logged in, desktop) ========== */}
        {!isMobile && token && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              flex: 1,
              justifyContent: "center",
              maxWidth: 560,
              mx: "auto",
            }}
          >
            {/* Home button */}
            <IconButton
              onClick={() => navigate("/EmployeeDashboard")}
              sx={{
                p: 1,
                borderRadius: "12px",
                color: "#667eea",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(102,126,234,0.08)",
                },
              }}
            >
              <HomeRoundedIcon sx={{ fontSize: 22 }} />
            </IconButton>

            {/* Search bar */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f5f7fb",
                border: "1px solid #eef0f6",
                borderRadius: "24px",
                px: 2,
                py: 0.75,
                flex: 1,
                maxWidth: 400,
                transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                "&:focus-within": {
                  borderColor: "#667eea",
                  boxShadow: "0 0 0 3px rgba(102,126,234,0.1)",
                },
              }}
            >
              <SearchIcon sx={{ fontSize: 20, color: "#9ca3af", mr: 1 }} />
              <input
                type="text"
                placeholder="Search employees, departments..."
                className="navbar-search-input"
              />
            </Box>

            {/* Fullscreen toggle */}
            <IconButton
              onClick={toggleFullscreen}
              sx={{
                p: 1,
                borderRadius: "12px",
                color: "#667eea",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(102,126,234,0.08)",
                },
              }}
            >
              {isFullscreen ? (
                <FullscreenExitRoundedIcon sx={{ fontSize: 22 }} />
              ) : (
                <FullscreenRoundedIcon sx={{ fontSize: 22 }} />
              )}
            </IconButton>
          </Box>
        )}

        {/* ========== RIGHT SECTION ========== */}
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, sm: 1 } }}>
          {token && employeeId && (
            <>
              {/* Chat icon with notification badge */}
              <IconButton
                onClick={() => navigate("/chatboard")}
                sx={{
                  p: { xs: 0.5, sm: 1 },
                  borderRadius: "12px",
                  color: "#667eea",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor: "rgba(102,126,234,0.08)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Badge
                  variant="dot"
                  overlap="circular"
                  sx={{
                    "& .MuiBadge-badge": {
                      width: { xs: 8, sm: 10 },
                      height: { xs: 8, sm: 10 },
                      borderRadius: "50%",
                      border: "2px solid #fff",
                      bgcolor: "#f5576c",
                      top: 2,
                      right: 2,
                    },
                  }}
                >
                  <ChatBubbleIcon sx={{ fontSize: { xs: 17, sm: 20 } }} />
                </Badge>
              </IconButton>

              {/* Timesheet icon */}
              <IconButton
                onClick={() => navigate("/timesheet")}
                sx={{
                  p: { xs: 0.5, sm: 1 },
                  borderRadius: "12px",
                  color: "#667eea",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor: "rgba(102,126,234,0.08)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <AssignmentRoundedIcon sx={{ fontSize: { xs: 17, sm: 20 } }} />
              </IconButton>

              {/* User avatar */}
              <Avatar
                onClick={handleUserIconClick}
                sx={{
                  width: { xs: 30, sm: 36 },
                  height: { xs: 30, sm: 36 },
                  cursor: "pointer",
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  color: "#fff",
                  fontSize: { xs: "0.75rem", sm: "0.85rem" },
                  fontWeight: 700,
                  ml: 0.5,
                  transition: "box-shadow 0.2s ease, transform 0.2s ease",
                  "&:hover": {
                    boxShadow: "0 0 0 3px rgba(102,126,234,0.2)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                {employeeName ? employeeName.charAt(0).toUpperCase() : "U"}
              </Avatar>

              {/* User dropdown menu */}
              <Menu
                anchorEl={userCardAnchorEl}
                open={openUserCard}
                onClose={handleUserCardClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                disableScrollLock
                PaperProps={{
                  elevation: 0,
                  sx: {
                    borderRadius: "16px",
                    mt: 1.5,
                    minWidth: 260,
                    px: 0,
                    py: 0,
                    overflow: "visible",
                    backgroundColor: "#fff",
                    border: "1px solid #eef0f6",
                    boxShadow:
                      "0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
                    zIndex: 1500,
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: -6,
                      right: 20,
                      width: 12,
                      height: 12,
                      bgcolor: "#fff",
                      transform: "rotate(45deg)",
                      border: "1px solid #eef0f6",
                      borderBottom: "none",
                      borderRight: "none",
                      zIndex: 0,
                    },
                  },
                }}
                MenuListProps={{
                  disablePadding: true,
                  sx: { p: 0 },
                }}
                container={document.body}
              >
                <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5 }}>
                  <Typography
                    fontWeight={700}
                    fontSize="1rem"
                    color="#1a1a2e"
                    sx={{ mb: 0.25 }}
                  >
                    {employeeName || "User"}
                  </Typography>
                  <Typography
                    fontSize="0.8rem"
                    color="#6b7280"
                    sx={{ mb: 1.5, wordBreak: "break-word" }}
                  >
                    {employeeEmail || "—"}
                  </Typography>
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      fontSize: "0.7rem",
                      background: "linear-gradient(135deg, #667eea, #764ba2)",
                      color: "#fff",
                      px: 1.5,
                      py: 0.4,
                      borderRadius: "20px",
                      fontWeight: 600,
                      letterSpacing: 0.5,
                    }}
                  >
                    {employeeId}
                  </Box>
                </Box>

                <Divider sx={{ borderColor: "#eef0f6" }} />

                <Box sx={{ py: 0.75 }}>
                  <MenuItem
                    onClick={() => {
                      handleUserCardClose();
                      navigate("/ResetPassword");
                    }}
                    sx={{
                      fontSize: "0.85rem",
                      color: "#374151",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      px: 2.5,
                      py: 1.25,
                      borderRadius: "8px",
                      mx: 1,
                      transition: "background-color 0.15s ease",
                      "&:hover": {
                        bgcolor: "rgba(102,126,234,0.06)",
                        color: "#667eea",
                      },
                    }}
                  >
                    <SettingsIcon sx={{ fontSize: 18 }} />
                    Settings
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleLogoutClick();
                      handleUserCardClose();
                    }}
                    sx={{
                      fontSize: "0.85rem",
                      color: "#DC2626",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      px: 2.5,
                      py: 1.25,
                      borderRadius: "8px",
                      mx: 1,
                      mb: 0.5,
                      transition: "background-color 0.15s ease",
                      "&:hover": {
                        bgcolor: "rgba(220,38,38,0.06)",
                      },
                    }}
                  >
                    <LogoutIcon sx={{ fontSize: 18 }} />
                    Logout
                  </MenuItem>
                </Box>
              </Menu>
            </>
          )}

          {/* Auth button */}
          {token ? (
            isMobile ? (
              <IconButton
                onClick={handleLogoutClick}
                sx={{
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  color: "#fff",
                  borderRadius: "10px",
                  p: 0.75,
                  ml: 0.5,
                  width: 30,
                  height: 30,
                  "&:hover": {
                    background: "linear-gradient(135deg, #5a6fd6, #6a4296)",
                  },
                }}
              >
                <LogoutIcon sx={{ fontSize: 16 }} />
              </IconButton>
            ) : (
              <Button
                onClick={handleLogoutClick}
                variant="contained"
                disableElevation
                sx={{
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  color: "#fff",
                  fontWeight: 600,
                  textTransform: "none",
                  px: 2.5,
                  py: 0.75,
                  fontSize: "0.8rem",
                  borderRadius: "20px",
                  minHeight: "34px",
                  ml: 1,
                  boxShadow: "0 4px 12px rgba(102,126,234,0.3)",
                  transition: "all 0.25s ease",
                  "&:hover": {
                    background: "linear-gradient(135deg, #5a6fd6, #6a4296)",
                    boxShadow: "0 6px 20px rgba(102,126,234,0.4)",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                Logout
              </Button>
            )
          ) : (
            <Button
              variant="outlined"
              onClick={handleLoginClick}
              startIcon={!isMobile ? <LoginRoundedIcon sx={{ fontSize: 18 }} /> : undefined}
              sx={{
                color: "#fff",
                borderColor: "rgba(255,255,255,0.5)",
                fontWeight: 600,
                textTransform: "none",
                px: { xs: 2, sm: 3 },
                py: 0.75,
                fontSize: { xs: "0.75rem", sm: "0.85rem" },
                borderRadius: "20px",
                minHeight: { xs: "30px", sm: "36px" },
                backdropFilter: "blur(4px)",
                transition: "all 0.25s ease",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.15)",
                  borderColor: "#fff",
                  transform: "translateY(-1px)",
                },
              }}
            >
              Login
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
